export class ShipmentChatTrackNumber {
  shipmentChatTrackNumber: string;
}
